<mat-accordion class="sidebar-accordian">
  <ng-container *ngFor="let route of navigationRoutes">
    <ng-container
      *ngTemplateOutlet="routeNode; context: { $implicit: route, level: 0 }"
    ></ng-container>
  </ng-container>
  <div class="version">
    <div class="text">v{{ version }}</div>
    <a class="link" [routerLink]="['/docs']">Docs</a>
  </div>
</mat-accordion>

<ng-template #routeNode let-route let-level="level">
  <div
    [ngClass]="{ opened: route.opened }"
    [class.depth-0]="level === 0"
    [class.depth-1]="level === 1"
    [class.depth-2]="level >= 2"
    *ngIf="route.show"
  >
    <button
      mat-button
      [ngClass]="{ 'navigation-button': true, 'sub-navigation-button': level > 0 }"
      [disabled]="route.disabled"
      [style.padding-left.px]="level > 1 ? 30 + (level - 1) * 12 : null"
      (click)="onNavigationClick(route)"
    >
      <svg-icon
        src="assets/svg/{{ route.icon }}.svg"
        [svgStyle]="route.iconStyle!"
        [svgClass]="route.iconClass || getRouteIconClass(level)"
      ></svg-icon>
      <div class="text">{{ route.name }}</div>
      <div *ngIf="route.subRoutes && route.subRoutes.length" class="arrow">
        <svg-icon
          *ngIf="route.closed"
          src="assets/svg/arrow-right.svg"
          [svgStyle]="{ 'width.px': '7', 'height.px': '12' }"
          svgClass="lightBlue"
        ></svg-icon>
        <svg-icon
          *ngIf="route.opened"
          src="assets/svg/arrow-down.svg"
          [svgStyle]="{ 'width.px': '12', 'height.px': '7' }"
          svgClass="lightBlue"
        ></svg-icon>
      </div>
    </button>
    <ng-container *ngIf="route.subRoutes && route.opened">
      <div *ngFor="let child of route.subRoutes">
        <ng-container
          *ngTemplateOutlet="routeNode; context: { $implicit: child, level: level + 1 }"
        ></ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>
